import React from 'react';
import moment from 'moment';

export default class CalendarDay extends React.Component {
    constructor(props) {
        super(props);

        this.newValue = null;
        this.lastValue = props.selected ? props.currentDay : null;
        this.onMonthClick = this.onMonthClick.bind(this);
    }
    
    shouldComponentUpdate(nextProps) {
        if(this.props.className.includes('selected') || nextProps.selected) 
            return true;

        const same = this.props.currentDay.isSame(this.newValue, 'day');
        const same1 = this.props.currentDay.isSame(this.lastValue, 'day');
        if(same) {
            this.lastValue = this.newValue;
        }
        else if(same1) {
            this.lastValue = null;
        }
        this.newValue = null;
        return same || same1;
    }

    onMonthClick(e) {
        if(e.stopPropagation)
            e.stopPropagation();
        e.preventDefault();

        const target = e.target;
        if(target.dataset.value) {
            this.newValue = moment(target.dataset.value);
        }
        this.props.onMonthClick(e);
    }

    render() {
        if(this.props.visible) {
            return(
                <td 
                    className={this.props.className}>
                    <div 
                        role="option"
                        onMouseDown={this.onMonthClick}
                        data-value={this.props.nearestTime}
                    >{this.props.currentDay.format('D')}</div>
                </td>
            );
        }
        else {
            return(
                <td className={this.props.className}/>
            );
        }
    }
}
